var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticStyle: {
        "background-color": "#F0F0EF",
        height: "535px",
        overflow: "auto"
      }
    },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c(
              "div",
              { staticClass: "d-flex justify-end" },
              [
                _c(
                  "span",
                  { staticClass: "mr-3 d-flex align-center search-title" },
                  [_vm._v("\n          Assign all tasks")]
                ),
                _vm._v(" "),
                !_vm.selectAll
                  ? _c("AssignmentMenu", {
                      attrs: {
                        selectAll: true,
                        disabledView: _vm.disabledView
                      },
                      on: {
                        addIndividualUser: function($event) {
                          return _vm.addSelectionToAll($event)
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectAll
                  ? _c("AssignmentTaskRemoveButton", {
                      staticClass: "button-hover",
                      attrs: {
                        selectAll: _vm.selectAll,
                        disabledView: _vm.disabledView
                      },
                      on: { remove: _vm.removeSelectAll }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex justify-start mt-5 flex-nowrap flex-column"
              },
              _vm._l(_vm.selectedTemplates, function(template, index) {
                return _c(
                  "v-col",
                  {
                    key: index,
                    staticClass: "d-flex justify-start flex-nowrap",
                    staticStyle: {
                      "margin-bottom": "25px",
                      "margin-left": "-40px"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "select-all-button" },
                      [
                        !_vm.templateSelectAll.find(function(item) {
                          return item.title === template.title
                        })
                          ? _c("AssignmentMenu", {
                              attrs: {
                                selectAll: true,
                                disabledView: _vm.disabledView
                              },
                              on: {
                                addIndividualUser: function($event) {
                                  return _vm.addSelectionToAll($event, template)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.templateSelectAll.find(function(item) {
                          return item.title === template.title
                        })
                          ? _c("AssignmentTaskRemoveButton", {
                              staticClass: "button-hover",
                              attrs: {
                                selectAll: _vm.templateSelectAll.find(function(
                                  item
                                ) {
                                  return item.title === template.title
                                }),
                                disabledView: _vm.disabledView
                              },
                              on: {
                                remove: function($event) {
                                  return _vm.removeSelectAll(template)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.receivedData.activities.find(function(item) {
                      return item.title === template.title
                    })
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-start justify-start pr-2 text-firefox"
                          },
                          [
                            _c("p", { staticClass: "rotate-text" }, [
                              _vm._v(_vm._s(template.title))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mr-4 right-side" },
                      _vm._l(_vm.receivedData.activities, function(
                        activity,
                        activityIndex
                      ) {
                        return _c(
                          "div",
                          { key: activityIndex },
                          [
                            activity.title === template.title
                              ? _c(
                                  "v-card",
                                  {
                                    staticClass:
                                      "d-flex flex-column align-center",
                                    staticStyle: {
                                      display: "relative",
                                      "margin-bottom": "30px",
                                      "margin-left": "20px"
                                    },
                                    attrs: {
                                      height: "130px",
                                      "max-width": "800px",
                                      width: "585px",
                                      elevation: "0",
                                      disabled: _vm.disabledView
                                    }
                                  },
                                  [
                                    _c(
                                      "v-sheet",
                                      {
                                        staticClass: "card-title",
                                        attrs: {
                                          width: "220",
                                          height: "30",
                                          rounded: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "text-truncate" },
                                          [
                                            activity.label
                                              ? _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: activity.label
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(activity.label) +
                                                        " - Activity"
                                                    )
                                                  ]
                                                )
                                              : activity.id
                                              ? _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title: activity.id
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getObjectTypeLabel(
                                                            activity.object_type
                                                          )
                                                        ) +
                                                        " ID\n                      " +
                                                        _vm._s(activity.id) +
                                                        " - Activity"
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title:
                                                        activity.object_uuid
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getObjectTypeLabel(
                                                            activity.object_type
                                                          )
                                                        ) +
                                                        " UUID -\n                      " +
                                                        _vm._s(
                                                          activity.object_uuid
                                                        )
                                                    )
                                                  ]
                                                )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass: "d-inline-flex",
                                        staticStyle: {
                                          overflow: "auto",
                                          "margin-top": "3px"
                                        }
                                      },
                                      _vm._l(activity.tasks, function(task, i) {
                                        return _c(
                                          "v-sheet",
                                          {
                                            key: i,
                                            staticClass:
                                              "ml-2 d-flex flex-column justify-space-between",
                                            attrs: {
                                              height: "55",
                                              rounded: "",
                                              outlined: "",
                                              width: "130"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "task-text text-truncate",
                                                attrs: { title: task.title }
                                              },
                                              [_vm._v(_vm._s(task.title))]
                                            ),
                                            _vm._v(" "),
                                            task.user_assignee_id ||
                                            (task.company_id &&
                                              !task.user_assignee_id &&
                                              activity.company &&
                                              activity.company.length <= 0)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-center justify-end pr-2 pl-2",
                                                    staticStyle: {
                                                      width: "100%"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-truncate",
                                                        attrs: {
                                                          title: task.user_assignee_id
                                                            ? _vm.getUserName(
                                                                task.user_assignee_id
                                                              )
                                                            : _vm.getCompanyName(
                                                                task.company_id
                                                              )
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            task.user_assignee_id
                                                              ? _vm.getUserName(
                                                                  task.user_assignee_id
                                                                )
                                                              : _vm.getCompanyName(
                                                                  task.company_id
                                                                )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "AssignmentTaskRemoveButton",
                                                      {
                                                        staticClass:
                                                          "button-hover",
                                                        attrs: {
                                                          tasks: task,
                                                          disabledView:
                                                            _vm.disabledView
                                                        },
                                                        on: {
                                                          remove: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeTaskAssignee(
                                                              task
                                                            )
                                                          }
                                                        }
                                                      }
                                                    )
                                                  ],
                                                  1
                                                )
                                              : !task.user_assignee_id
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-end justify-end pt-2",
                                                    staticStyle: {
                                                      width: "100%"
                                                    }
                                                  },
                                                  [
                                                    _c("AssignmentMenu", {
                                                      key: i,
                                                      attrs: {
                                                        activity: activity,
                                                        disabledView:
                                                          _vm.disabledView
                                                      },
                                                      on: {
                                                        addIndividualUser: function(
                                                          $event
                                                        ) {
                                                          return _vm.addIndividualUser(
                                                            $event,
                                                            i,
                                                            activityIndex
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-inline-flex align-end justify-end",
                                        staticStyle: { width: "97%" }
                                      },
                                      [
                                        _vm._l(activity.company, function(
                                          company,
                                          i
                                        ) {
                                          return _c(
                                            "div",
                                            { key: i },
                                            [
                                              _c("AssignmentRemoveButton", {
                                                staticClass: "button-hover",
                                                attrs: {
                                                  actionType: _vm.actionType,
                                                  activity: activity,
                                                  company: company
                                                },
                                                on: {
                                                  remove: function($event) {
                                                    return _vm.remove($event)
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "ml-2 mt-2" },
                                          [
                                            _c("AssignmentMenu", {
                                              attrs: {
                                                activity: activity,
                                                activityMenu: true
                                              },
                                              on: {
                                                addCompanyOrUser: function(
                                                  $event
                                                ) {
                                                  return _vm.addCompanyOrUser(
                                                    $event,
                                                    activity
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]
                )
              }),
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-686d2388", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-686d2388","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/WorkOrderAssignment.vue
// module id = null
// module chunks = 